import { render, staticRenderFns } from "./ChoicePaymentCancel.vue?vue&type=template&id=30b384c0&scoped=true&"
import script from "./ChoicePaymentCancel.vue?vue&type=script&lang=js&"
export * from "./ChoicePaymentCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b384c0",
  null
  
)

export default component.exports